// extracted by mini-css-extract-plugin
export default {"businessNameContainer":"KX1mcP","businessNameInput":"sbk9lM","businessName_subtitle":"aAIOlQ","businessNameSubtitle":"aAIOlQ"};